import React from "react";

const CategoryChip = ({
  target,
  label,
  isActive,
  onClick
}: {
  target: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}) => {
  return (
    <div className="chip is-choice">
      <input type="radio" checked={isActive} name="menu_category" value={target} id={`${target}-button`} onChange={onClick} />
      <label htmlFor={`${target}-button`} >{label}</label>
    </div>
  );
}

export { CategoryChip };
